<template>
  <header>
    <div class="row">
      <div class="col s6">
        <a href="/">
          <img class="center-align logo" id="marcaAbout" src="@/assets/img/logo_recad_branca.svg" alt="logo" />
        </a>
      </div>
      <div class="col s6 no-padding">
        <h4 class="soliciteAcessAbout">
          <router-link to="/Ajuda/">
            AJUDA
          </router-link>
        </h4>
        <!-- <h4 class="fazerLoginTopAbout fAboutLogin hide-on-med-and-down"></h4> -->
      </div>
    </div>
  </header>
</template>
<script>
import axios from "axios";
import Loading from "./Loading.vue";
import { CONFIG } from "@/config/config";
import { formataCPF } from "@/assets/js/form-utils";
import { validaCPF } from "@/assets/js/script";
import { logOut, closeRightSidebar } from "@/assets/js/scripts-login";
import SocialService from "@/services/social-service.js";

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2);

export default {
  name: "Header",
  components: {
    loading: Loading
  },
  props: {
    no_auth: Boolean
  },
  data() {
    return {
      loading: true,
      pf_id: this.$route.params.pf_id,
      meta: this.$store.state.meta.data,
      logOut: logOut
    };
  },
  methods: {
    initFields() {
      M.Modal.init(document.querySelectorAll(".modal"));
      M.Sidenav.init(document.querySelectorAll(".sidenav"));
    },
    goToHelp() {
      if (this.$route.path !== "/Ajuda/") {
        this.$router.push("/Ajuda/");
      }
      var instanceSidenav = M.Sidenav.getInstance(
        document.querySelector(".sidenav")
      );
      instanceSidenav.close();
    },
    goToHome() {
      this.$router.push("/");
      var instanceSidenav = M.Sidenav.getInstance(
        document.querySelector(".sidenav")
      );
      instanceSidenav.close();
    }
  },
  mounted() {
    this.$root.$on("loadingHeader", () => {
      this.loading = true;
    });

    this.$root.$on("stopLoadingHeader", () => {
      this.loading = false;
    });

    this.initFields();
  },
  updated() {}
};
</script>



// WEBPACK FOOTER //
// src/components/HeaderAbout.vue